export const BasketballGoalIcon = ({ className = "h-5 w-5" }) => {
  return (
    <img 
      src="/basketball-goal-icon.png" 
      alt="Basketball Goal" 
      className={className}
      style={{ filter: 'brightness(0) invert(1)' }}
    />
  );
};
